"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoginForm", {
  enumerable: true,
  get: function get() {
    return _LoginForm.default;
  }
});
Object.defineProperty(exports, "RichText", {
  enumerable: true,
  get: function get() {
    return _RichText.default;
  }
});
Object.defineProperty(exports, "GatsbyImage", {
  enumerable: true,
  get: function get() {
    return _GatsbyImage.default;
  }
});
Object.defineProperty(exports, "isLoggedIn", {
  enumerable: true,
  get: function get() {
    return _auth.isLoggedIn;
  }
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _JamCMS = _interopRequireDefault(require("./JamCMS"));

var _LoginForm = _interopRequireDefault(require("./components/LoginForm"));

var _RichText = _interopRequireDefault(require("./components/RichText"));

var _GatsbyImage = _interopRequireDefault(require("./components/GatsbyImage"));

var _auth = require("./utils/auth"); // import app components


var Index = function Index(props) {
  var source = props.source;
  return (0, _auth.isLoggedIn)() || (0, _auth.isPreview)() ? /*#__PURE__*/_react.default.createElement(_JamCMS.default, props) : /*#__PURE__*/_react.default.cloneElement(props.children, {
    source: source
  });
};

var _default = Index;
exports.default = _default;